export const TrendsInsightsSchema = [
	{
		id: 'title',
		element: 'text',
		label: 'Title',
		placeholder: 'Enter Title',
		disabled: false,
		validationType: "string",
		validations: [
			{
				type: "matches",
				params: ['^$|^[a-zA-Z0-9 !@#$%^&*)(\\-+=.,]+$', "This field contains an invalid character."]
			},
			{
				type: "max",
				params: [255, "This field cannot be more than 255 characters."]
			}
		]
	},
	{
		id: 'subtitle',
		element: 'text',
		label: 'Sub Title',
		placeholder: 'Enter Sub Title',
		disabled: false,
		validationType: "string",
		validations: [
			{
				type: "matches",
				params: ['^$|^[a-zA-Z0-9 !@#$%^&*)(\\-+=.,]+$', "This field contains an invalid character."]
			},
			{
				type: "max",
				params: [255, "This field cannot be more than 255 characters."]
			}
		]
	}
];